(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('LabNotificationDeleteController',LabNotificationDeleteController);

    LabNotificationDeleteController.$inject = ['$uibModalInstance', 'entity', 'LabNotification'];

    function LabNotificationDeleteController($uibModalInstance, entity, LabNotification) {
        var vm = this;

        vm.labNotification = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            LabNotification.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
